import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    children: [
      {
        component: () =>
          import('#/views/email-notifications/templates/index.vue'),
        meta: {
          icon: 'mdi:email-edit-outline',
          keepAlive: true,
          title: '提醒邮件模板',
        },
        name: 'EmailNotificationTemplates',
        path: '/email-templates',
      },
      {
        component: () =>
          import('#/views/email-notifications/send-logs/index.vue'),
        meta: {
          icon: 'mdi:email-fast-outline',
          keepAlive: true,
          title: '邮件发送日志',
        },
        name: 'EmailNotificationSendLogs',
        path: '/email-send-logs',
      },
      {
        component: () => import('#/views/email-notifications/usage/index.vue'),
        meta: {
          icon: 'mdi:chart-donut',
          keepAlive: true,
          title: '邮件发送用量统计',
        },
        name: 'EmailNotificationUsage',
        path: '/email-usage',
      },
    ],
    meta: {
      icon: 'mdi:email-multiple-outline',
      order: 120,
      title: '邮件通知',
    },
    name: 'EmailNotifications',
    path: '/email-notifications',
  },
]

export default routes
